import { Group, Stack, Text } from '@mantine/core';
import React from 'react';
import { datasetToFileTypeAndIcon } from '@/pages/AutomationPage/components/DatasetItemUtils.ts';
import { useHover } from '@mantine/hooks';
import { Link } from 'react-router-dom';
import useAutomationId from '@/hooks/useAutomationId';
import DatasetIcon from '@/components/DatasetIcon.tsx';
import { Run } from '@/types/runs.ts';
import { Dataset } from '@/types/datasets.ts';

type props = {
  run: Run;
  dataset: Dataset;
  bottomBorder: boolean;
};

const DatasetItem = ({ run, dataset, bottomBorder }: props) => {
  const { fileType } = datasetToFileTypeAndIcon(dataset);

  const { hovered, ref: hoverRef } = useHover();

  const automationId = useAutomationId();

  const url = dataset.is_natual_directory
    ? `/automations/${automationId}/results/${run.id}?datasetId=${dataset.id}&showChat=true`
    : `/automations/${automationId}/results/${run.id}?datasetIds=${dataset.id}&showChat=true`;

  return (
    <Link to={url} style={{ display: 'contents', textDecoration: 'none' }}>
      <Group
        px={'md'}
        h={'60px'}
        align={'center'}
        style={{
          background: hovered ? '#F2F6F7' : 'transparent',
          borderBottom: bottomBorder ? '1px solid #E8E8E8' : 'none',
        }}
        ref={hoverRef}
        wrap={'nowrap'}
      >
        <DatasetIcon dataset={dataset} size={'34px'} borderRadius={'8px'} />

        <Stack gap={'4px'} style={{ flex: 1, minWidth: 0 }}>
          <Text c={'#0F172A'} truncate={'end'} size={'14px'} fw={500} lh={'1.1'}>
            {dataset.name}
          </Text>
          <Text c={'#757575'} truncate={'end'} size={'12px'}>
            {fileType}
          </Text>
        </Stack>
      </Group>
    </Link>
  );
};

export default DatasetItem;
